var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicagentWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 427,
    height: 121,
    viewBox: "0 0 427 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12028_2935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1016 35.9L36.6216 28.91L24.8816 26.55L2.06165 21.95L10.8316 46.05L26.1016 35.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2416 35.73L94.7416 23.29L99.2016 1.17L75.1016 9.94L92.2416 35.73Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5816 0L2.55164 19.48L90.1416 37.12L82.3716 25.43L72.4116 10.44L20.5816 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.672 1.66L94.1216 39.15C94.1216 39.15 94.1016 39.22 94.1016 39.25L84.0316 89.25L110.722 71.51L121.162 19.69L101.662 1.66H101.672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.832 80.45L85.4216 91.35L119.982 98.31L111.212 74.21L101.832 80.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0116 31.01L11.3316 48.75L0.891602 100.57L20.3716 118.6L38.0116 31.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.462 120.26L119.492 100.78L81.9416 93.22L31.9016 83.14L34.1416 86.5L49.6416 109.82L101.462 120.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8016 84.53L25.6916 104.96L22.8416 119.09L46.9416 110.32L29.8016 84.53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.692 87.84V98.13H146.912V65.09H158.902C165.982 65.09 170.702 70.38 170.702 76.42C170.702 82.46 165.982 87.84 158.902 87.84H150.692ZM158.522 84.58C164.002 84.58 166.972 80.57 166.972 76.42C166.972 72.27 164.002 68.35 158.522 68.35H150.692V84.58H158.522Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.862 65.09H183.642V98.13H179.862V65.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.672 74.57H223.942C221.722 70.51 217.522 67.73 211.812 67.73C203.642 67.73 197.982 73.77 197.982 81.61C197.982 89.45 203.642 95.49 211.812 95.49C217.522 95.49 221.722 92.7 223.942 88.65H227.672C225.262 94.6 219.412 98.8 211.812 98.8C201.622 98.8 194.212 91.34 194.212 81.62C194.212 71.9 201.622 64.44 211.812 64.44C219.412 64.44 225.262 68.64 227.672 74.59V74.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.452 91H257.182L254.302 98.13H250.382L264.262 65.09H267.382L281.262 98.13H277.342L274.462 91H274.452ZM258.452 87.84H273.182L265.822 69.43L258.462 87.84H258.452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.942 74.43C314.722 70.42 310.622 67.73 304.952 67.73C296.742 67.73 291.072 73.54 291.072 81.61C291.072 89.68 296.882 95.58 304.952 95.58C312.272 95.58 316.562 91.28 318.122 85.81H302.972V82.69H322.132C321.562 91.52 315.102 98.78 304.952 98.78C294.802 98.78 287.302 91.32 287.302 81.6C287.302 71.88 294.612 64.42 304.952 64.42C312.312 64.42 317.932 68.1 320.712 74.43H316.932H316.942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.522 65.09H353.382V68.39H336.292V79.67H352.952V82.97H336.292V94.82H353.562V98.12H332.512V65.08L332.522 65.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.722 65.09H366.652L388.222 92.23V65.09H391.712V98.13H388.782L367.212 70.99V98.13H363.722V65.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.742 68.34H415.932V98.12H412.152V68.34H401.342V65.08H426.732V68.34H426.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.262 34.36C167.262 30.4 164.822 26.64 160.072 26.64C155.322 26.64 152.922 30.39 152.922 34.36C152.922 38.33 155.332 42.08 160.072 42.08C164.812 42.08 167.262 38.29 167.262 34.36ZM173.282 34.36C173.282 41.47 168.182 47.24 160.082 47.24C151.982 47.24 146.912 41.47 146.912 34.36C146.912 27.25 151.972 21.47 160.082 21.47C168.192 21.47 173.282 27.24 173.282 34.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.612 35.03C194.842 35.03 196.572 33.51 196.572 31.1C196.572 28.69 194.842 27.14 192.612 27.14H187.412V35.03H192.612ZM189.882 40.2H187.402V46.75H181.382V21.97H193.452C198.692 21.97 202.582 25.93 202.582 31.1C202.582 34.96 200.422 38.07 197.202 39.45L203.932 46.74H195.822L189.872 40.19L189.882 40.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.152 46.75V21.97H216.172V46.75H210.152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.472 33.55H250.812V34.05C250.812 41.7 245.642 47.25 237.852 47.25C229.602 47.25 224.542 41.37 224.542 34.37C224.542 27.37 229.672 21.48 237.852 21.48C244.122 21.48 248.652 24.98 250.242 30.54H244.292C243.232 28.42 241.252 26.65 237.882 26.65C233.312 26.65 230.552 29.87 230.552 34.37C230.552 39.33 233.352 42.26 237.812 42.26C241.072 42.26 243.302 40.63 244.222 38.47H236.472V33.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.632 38.32H272.392L269.032 28.97L265.632 38.32ZM274.162 43.25H263.862L262.622 46.75H256.112L266.762 21.97H271.292L281.942 46.75H275.432L274.162 43.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.122 37.97L311.932 21.97H315.972V46.75H310.162V34.75L302.122 47.1L294.082 34.75V46.75H288.272V21.97H292.312L302.122 37.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.202 46.75V21.97H330.222V46.75H324.202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.222 47.25C341.702 47.25 338.512 43.99 338.092 39.14H343.822C344.032 40.95 345.022 42.36 347.362 42.36C349.202 42.36 350.512 41.12 350.512 39.63C350.512 38.29 349.702 37.4 348.102 36.98L344.812 36.09C341.092 35.1 338.472 33.08 338.472 29.19C338.472 24.23 342.262 21.47 347.112 21.47C351.962 21.47 355.222 24.97 355.362 29.29H349.872C349.802 27.73 348.882 26.35 347.072 26.35C345.262 26.35 344.382 27.27 344.382 28.58C344.382 29.96 345.412 30.53 346.962 30.95L350.152 31.84C354.082 32.94 356.422 34.99 356.422 39.13C356.422 44.26 351.712 47.24 347.222 47.24V47.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.212 38.32H391.972L388.612 28.97L385.212 38.32ZM393.742 43.25H383.442L382.202 46.75H375.692L386.352 21.97H390.882L401.532 46.75H395.022L393.752 43.25H393.742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.032 46.75V21.97H414.052V46.75H408.032Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12028_2935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 425.85,
    height: 120.26,
    fill: "white",
    transform: "translate(0.891602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicagentWhite);
export default __webpack_public_path__ + "static/media/picagent-White.9e29bfad10ab6b83522f3ba53412d59d.svg";
export { ForwardRef as ReactComponent };